import { FormattedMessage } from 'react-intl';

function FormattedText({ id, defaultValue, ...props }) {
    return <FormattedMessage id={id} defaultValue={defaultValue} {...props} />;
}

export default FormattedText;
